'use client';

import { createContext, useContext } from "react";

export const IndividualsContext = createContext(null);
export const useIndividualsCtx = () => {
  const v = useContext(IndividualsContext);
  if (!v) throw new Error("useIndividualsCtx used outside <IndividualsModule>.");
  return v;
};

export const defaultCopy = {
  page_title: "Individual customers",
  page_subtitle: "People you've won — one record per phone number.",
  cta_add: "Add customer",
};

export const errText = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong. Please try again.";

export const initialsOf = (name) =>
  (name || "?").trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join("").toUpperCase();

export const formatPhone = (raw) => {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length !== 10) return raw || "";
  return `${d.slice(0, 5)} ${d.slice(5)}`;
};
